import { render, staticRenderFns } from "./EditCompany.vue?vue&type=template&id=ede9270a&scoped=true"
import script from "./EditCompany.vue?vue&type=script&lang=js"
export * from "./EditCompany.vue?vue&type=script&lang=js"
import style0 from "./EditCompany.vue?vue&type=style&index=0&id=ede9270a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ede9270a",
  null
  
)

export default component.exports